"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DevelopmentModeWarning;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("br", null);
var _ref2 = /*#__PURE__*/_react.default.createElement("br", null);
// Warning bar for non-live environments
function DevelopmentModeWarning() {
  // Want to display a red warning bar for staging and development environments
  // so checking for staging in hostname
  // Note that NODE_ENV is 'production' in staging to run same code as live production site
  const environment = "production" === 'production' && typeof document !== 'undefined' && /staging/.test(document.location.hostname) ? 'staging' : "production";
  if (environment !== 'production') {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("nav", {
      className: "navbar navbar-dark",
      style: {
        backgroundColor: 'red'
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "text-xs-center"
    }, "NOT Live - ", environment, " environment")), _ref, _ref2);
  }
  return null;
}